import { Injectable } from '@angular/core';
import { initializeEcho, getEcho } from '../../config/laravel-echo';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EchoService {

  private echo: any = null;

  private userChannel: any;
  private onboardingWebChannel: any;
  private learningWebChannel: any;
  private globalUser: any;

  constructor() { }

  setChannels(user, token, configData) {
    if(!configData?.settings?.sockets?.webapp?.enabled ||
      !configData?.settings?.sockets?.webapp?.credentials?.appKey ||
      !configData?.settings?.sockets?.webapp?.credentials?.host
    ) {
      // console.log("setChannels...3");
      return;
    }
    console.log("setChannels...2");
    let pusherApiUrl = environment.MIX_PUSHER_BACKEND_API;
    if(environment.APP_MULTIMARCA) {
      const apiUrlForBrand = JSON.parse(localStorage.getItem("api_urls"));
      pusherApiUrl = apiUrlForBrand.serviceBase;
    };

    this.echo = initializeEcho(token, configData?.settings?.sockets?.webapp?.credentials?.appKey, configData?.settings?.sockets?.webapp?.credentials?.host, pusherApiUrl );
    // this.echo.connector.options.auth.headers.Authorization = 'Bearer ' + token

    // todos
    this.userChannel =  this.echo.private('users.' + user.id);
    this.userChannel.notification((notification) => {
      console.log('notification');
      console.log(notification);
    });

    this.globalUser = this.echo.join('global.users');
    this.globalUser.listen('TestEventChannel', (e) => {
        console.log('TestEventChannel global-user');
        console.log(e);
    })
    .error((error) => {
        console.error('error');
        console.error(error);
    });


    if(user.onboarding) {
        // solo desde inducción
        //  this.onboardingWebUsersChannel = this.echo.private('onboarding.web.users.' + user.id);
        // this.onboardingWebUsersChannel.notification((notification) => {
        //   console.log('notification');
        //   console.log(notification);
        // });

        this.onboardingWebChannel = this.echo.join('onboarding.web');
        this.onboardingWebChannel
        .listen('TestEventChannel', (e) => {
            console.log('TestEventChannel');
            console.log(e);
        })
        .error((error) => {
            console.error('error');
            console.error(error);
        });

    } else {
      // solo desde aprendizaje/capacitación

      this.learningWebChannel = this.echo.join('learning.web');

      this.learningWebChannel
      .listen('TestEventChannel', (e) => {
          console.log('TestEventChannel');
          console.log(e);
      })
      .error((error) => {
          console.error('error');
          console.error(error);
      });

    };

  }


  leaveAllChannels() {
    console.log("Leaving all Echo channels..1.", this.userChannel, this.learningWebChannel);

    // Desuscribirse de canales privados
    if (this.userChannel) {
      this.echo.leave('private-users.' + this.getUserIdFromChannel(this.userChannel));
      this.userChannel = null;
    }

    // Desuscribirse de canales de presencia
    if (this.onboardingWebChannel) {
      this.echo.leave('presence-onboarding.web');
      this.onboardingWebChannel = null;
    }

    if (this.learningWebChannel) {
      this.echo.leave('presence-learning.web');
      this.learningWebChannel = null;
    }

    if (this.globalUser) {
      this.echo.leave('presence-global.users');
      this.globalUser = null;
    }

    console.log("Leaving all Echo channels..2.", this.userChannel, this.learningWebChannel);

    // if (this.echo && this.echo.connector && this.echo.connector.options && this.echo.connector.options.auth) {
    //   this.echo.connector.options.auth.headers.Authorization = '';
    // }

    const echoRef = getEcho();
    if(echoRef) {
      echoRef.disconnect();
    }
    this.echo = null;
  }

  private getUserIdFromChannel(channel): string {
    if (!channel) return '';

    const channelName = channel.name;
    const parts = channelName.split('.');
    return parts[parts.length - 1];
  }
}
